import { render, staticRenderFns } from "./user-edit-box.vue?vue&type=template&id=b3efaeb2&scoped=true&"
import script from "./user-edit-box.vue?vue&type=script&lang=js&"
export * from "./user-edit-box.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-box.vue?vue&type=style&index=0&id=b3efaeb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3efaeb2",
  null
  
)

export default component.exports